// Importa as funções necessárias do SDK do Firebase
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase, ref, push, onValue, set } from "firebase/database";
// Configuração do Firebase (NÃO exponha estas credenciais publicamente)
const firebaseConfig = {
  apiKey: "AIzaSyCwlUvfTzMCsqS6tfu-YdEvTlIE-uRmRbQ",
  authDomain: "karingana-unitymoz.firebaseapp.com",
  projectId: "karingana-unitymoz",
  storageBucket: "karingana-unitymoz.firebasestorage.app",
  messagingSenderId: "132258881493",
  appId: "1:132258881493:web:dd63dcb577ebf5c147675c",
  measurementId: "G-MVW25DMCGW"
};

// Inicializa o Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app)
const database = getDatabase(app);
const db = getFirestore(app); // Inicializa o Firestore

export { auth, db, database, ref, push, onValue, set };
